import { render } from "./AppTechnologies.vue?vue&type=template&id=53b80d6e"
import script from "./AppTechnologies.vue?vue&type=script&lang=js"
export * from "./AppTechnologies.vue?vue&type=script&lang=js"

import "./AppTechnologies.vue?vue&type=style&index=0&id=53b80d6e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__